import SuperRepository from '../superRepository'

export default new (class PanelsRepository extends SuperRepository {
  baseUri() {
    return 'block'
  }
  adminBlocks = (params) => this.httpClient().get(this.baseUri() + '/admin_list', params)
})()
